import { Alert, Button, Modal } from "react-bootstrap";

import dayjs from "dayjs";
import "dayjs/locale/fr";
import "antd/dist/reset.css";
import { Seance, Slot } from "./scheduler";
import { createEDTCours, saveVersionAs } from "../../api/edt";
import { toast } from "sonner";
import { getWeeksMondaySunday } from "../../helper/getWeeksMondaySunday";
import { useState } from "react";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

type Props = {
  show: boolean;
  idEDT: string;
  idVersionEDT: string;
  timetableData?: any;
  published?: boolean;
  days: any[];
  classes: { id: string; name: string }[];
  slots: any[];
  seances: any[];
  placedCourses: any[];
  setTimetableId: (param: string) => void;
  setTimetableVersion: (param: string) => void;
  onClose: () => void;
};

const EDTSaveModal = ({
  show,
  seances,
  slots,
  days,
  classes,
  published,
  timetableData,
  idEDT,
  idVersionEDT,
  placedCourses,
  setTimetableId,
  setTimetableVersion,
  onClose,
}: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingAs, setIsLoadingAs] = useState<boolean>(false);
  const [isPublished, setIsPublished] = useState<boolean>(false);
  const coursesWithoutRoom = placedCourses.filter(
    (placedCourse: any) => !placedCourse.classroomId,
  );

  const onSave = async () => {
    setIsLoading(true);
    try {
      if (coursesWithoutRoom.length > 0) {
        toast.error("Attribuez une salle à chaque cours avant d'enregistrer l'EDT.");
        return;
      }
      if (!timetableData) {
        toast.error("Erreur lors de la récupération des données de l'EDT");
        return;
      }

      // console.log("placedCourse: ", placedCourses);

      const validStart: Date = new Date(timetableData?.valid_from);

      // console.log("validDate: ",validStart)
      const placedCourseWithInterval = placedCourses.map(
        (placedCourse: any) => {
          //   console.log("slotsIds: ", placedCourse.slotsIds[0]);
          return {
            ...placedCourse,
            sessionStart: slots.find(
              (slot: Slot) => slot?.id === placedCourse.slotsIds[0],
            ),
          };
        },
      );
      // console.log("validStart: ",validStart)

      // le weekend correspondant à la semaine de validité de l'EDT
      const week: Date[] =
        getWeeksMondaySunday(
          validStart.getFullYear() || new Date().getFullYear(),
        ).find((week: Date[]) =>
          week.some(
            (day: Date) =>
              day.getDate() === validStart.getDate() &&
              day.getMonth() === validStart.getMonth(),
          ),
        ) || [];

      let formattedPlacedCourse = placedCourseWithInterval.map((item: any) => ({
        // ...item,
        matchedClassesCours: item.matchedClassesCours,
        day_course: days.find((day: any) => day?.id === item.day_course).name,
        reason_cancel: item?.reason_cancel,
        date_course:
          week?.length > 0
            ? dayjs(
                week[days.findIndex((d: any) => d?.id === item.day_course)],
              ).format("YYYY-MM-DD")
            : dayjs(validStart)
                .add(
                  days.findIndex((d: any) => d?.id === item.day_course) - 1,
                  "day",
                )
                .toDate(),
        id_course: item.course?.id,
        state_course: item.status,
        type_course: item.state,
        id_classroom: item?.classroomId,
        id_sessionStart: seances.find(
          (seance: Seance) =>
            seance.index === item.sessionStart.seanceIndex + 1,
        )?.id,
        id_sessionEnd: seances.find(
          (seance: Seance) =>
            seance.index ===
            item.sessionStart.seanceIndex + (item.seance_num ?? item.course.seance_num),
        )?.id,
      }));

      // console.log("FormattedPlacedCourse: ",formattedPlacedCourse)
      await createEDTCours({
        id_versionEDT: idVersionEDT,
        courses: formattedPlacedCourse,
      });
      //   setTimetableId?.(response.data.id);
      //   setTimetableVersion?.(response.data.version.id);
      //   console.log("response: ", res);
      toast.success("Emploi du temps enregistré avec succès ");
      onClose();
    } catch (error: any) {
      // console.log("erreur lors de l'enregistrement des cours : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = async () => {
    setIsLoadingAs(true);
    try {
      if (coursesWithoutRoom.length > 0) {
        toast.error("Attribuez une salle à chaque cours avant d'enregistrer l'EDT.");
        return;
      }
      if (!timetableData) {
        toast.error("Erreur lors de la récupération des données de l'EDT");
        return;
      }

      // console.log("timetableData: ", timetableData);

      const validStart: Date = new Date(timetableData?.valid_from);

      // console.log("validDate: ",validStart)
      const placedCourseWithInterval = placedCourses.map(
        (placedCourse: any) => {
          //   console.log("slotsIds: ", placedCourse.slotsIds[0]);
          return {
            ...placedCourse,
            sessionStart: slots.find(
              (slot: Slot) => slot.id === placedCourse.slotsIds[0],
            ),
          };
        },
      );
      // console.log("validStart: ",validStart)

      // le week correspondant à la semaine de validité de l'EDT
      const week: Date[] =
        getWeeksMondaySunday(
          validStart.getFullYear() || new Date().getFullYear(),
        ).find((week: Date[]) =>
          week.some(
            (day: Date) =>
              day.getDate() === validStart.getDate() &&
              day.getMonth() === validStart.getMonth(),
          ),
        ) || [];

      let formattedPlacedCourse = placedCourseWithInterval.map((item: any) => ({
        // ...item,
        day_course: days.find((day: any) => day?.id === item.day_course).name,
        reason_cancel: item?.reason_cancel,
        date_course:
          week?.length > 0
            ? dayjs(
                week[days.findIndex((d: any) => d.id === item.day_course)],
              ).format("YYYY-MM-DD")
            : dayjs(validStart)
                .add(
                  days.findIndex((d: any) => d.id === item.day_course) - 1,
                  "day",
                )
                .toDate(),
        id_course: item.course.id,
        state_course: item.status,
        type_course: item.state,
        id_classroom: item?.classroomId,
        id_sessionStart: seances.find(
          (seance: Seance) =>
            seance.index === item.sessionStart.seanceIndex + 1,
        )?.id,
        id_sessionEnd: seances.find(
          (seance: Seance) =>
            seance.index ===
            item.sessionStart.seanceIndex + (item.seance_num ?? item.course.seance_num),
        )?.id,
      }));

      // console.log("FormattedPlacedCourse: ",{
      //   id_versionEDT: idVersionEDT,
      //   state_edt: "Brouillon",
      //   courses: formattedPlacedCourse,
      // })
      const res = await saveVersionAs({
        id_versionEDT: idVersionEDT,
        state_edt: "Brouillon",
        courses: formattedPlacedCourse,
      });
      setTimetableId(res.data.edtId);
      setTimetableVersion(res.data.version.id);
      // console.log("response: ", res);
      toast.success("Emploi du temps enregistré avec succès ");
      onClose();
    } catch (error: any) {
      // console.log("erreur lors de l'enregistrement des cours : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingAs(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Enregistrer l'emploi du temps</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Voulez-vous vraiment enregistrer cet emploi du temps ?</p>
        {coursesWithoutRoom.length > 0 && (
          <Alert variant="warning" className="mb-0">
            <strong>Des salles restent à définir.</strong>
            <p className="mb-2">
              Attribuez une salle à chaque cours ci-dessous avant de pouvoir enregistrer :
            </p>
            <ul className="mb-0">
              {coursesWithoutRoom.map((placedCourse: any, index: number) => {
                const startSlot = slots.find(
                  (slot: Slot) => slot.id === placedCourse.slotsIds?.[0],
                );
                const firstSessionIndex = startSlot?.seanceIndex ?? 0;
                const sessionCount = placedCourse.seance_num ?? placedCourse.course?.seance_num ?? 1;
                const courseSessions = seances.filter(
                  (session: Seance) =>
                    session.index >= firstSessionIndex + 1 &&
                    session.index <= firstSessionIndex + sessionCount,
                );
                const classNames = placedCourse.slotsIds
                  ?.map((slotId: string) =>
                    slots.find((slot: Slot) => slot.id === slotId)?.classeId,
                  )
                  .map((classId: string) =>
                    classes.find((classe) => classe.id === classId)?.name,
                  )
                  .filter(Boolean);
                const teacher = placedCourse.course?.TeacherProfil;

                return (
                  <li key={`${placedCourse.course?.id}-${placedCourse.slotsIds?.[0] || index}`}>
                    {placedCourse.course?.Subject?.label || "Cours sans matière"}
                    {teacher &&
                      ` — ${[teacher.firstname, teacher.lastname].filter(Boolean).join(" ")}`}
                    {startSlot &&
                      ` — ${days.find((day) => day.id === placedCourse.day_course)?.name || "Jour"}`}
                    {courseSessions.length > 0 &&
                      `, ${courseSessions[0].start_time} - ${courseSessions[courseSessions.length - 1].end_time}`}
                    {classNames?.length > 0 && ` — ${classNames.join(", ")}`}
                  </li>
                );
              })}
            </ul>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex gap-4">
        {isLoadingAs ? (
          <Button variant="secondary" disabled={true}>
            <span
              className="spinner-border spinner-border-sm align-middle me-1"
              role="status"
              aria-hidden="true"
            />
            Enregistrement ...
          </Button>
        ) : (
          <Button variant="secondary" onClick={() => onSubmit()} disabled={coursesWithoutRoom.length > 0}>
            Enregistrer sous
          </Button>
        )}
        {isLoading ? (
          <Button variant="outline-primary" disabled={true}>
            <span
              className="spinner-border spinner-border-sm align-middle me-1"
              role="status"
              aria-hidden="true"
            />
            Enregistrement...
          </Button>
        ) : (
          <Button variant="outline-primary" onClick={() => onSave()} disabled={coursesWithoutRoom.length > 0}>
            Enregistrer
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default withPermission(
  EDTSaveModal,
  [
    buildPermission(Resource.EDT, Action.CREATE),
    buildPermission(Resource.EDT, Action.UPDATE),
  ],
  "masquer",
);
